import axios from 'axios';

const getFornecedorPagina = id => axios.get(`fornecedor/${id}/visualizacao`);

export default {
  getFornecedorPagina,
};
